/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Discount
 */
export interface Discount {
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof Discount
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof Discount
     */
    reference?: string;
}

/**
 * Check if a given object implements the Discount interface.
 */
export function instanceOfDiscount(value: object): boolean {
    return true;
}

export function DiscountFromJSON(json: any): Discount {
    return DiscountFromJSONTyped(json, false);
}

export function DiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): Discount {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'type': json['type'] == null ? undefined : json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'reference': json['reference'] == null ? undefined : json['reference'],
    };
}

export function DiscountToJSON(value?: Discount | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'currency': value['currency'],
        'type': value['type'],
        'amount': value['amount'],
        'reference': value['reference'],
    };
}

